
import React, { Component}  from 'react';

import { DetailProvider, DetailContext } from 'core/DetailProvider';
import { FormContext, FormProvider } from 'core/FormProvider';
import Layout from 'components/Dashboard/Layout';
import { YellowButton } from 'ui/Button';
import { ClientAddForm } from './AddForm';
import ClientDetailHeader from "./DetailHeader";
import { StyledClientDetailOrders } from './Styled';


export default class ClientEdit extends Component {

  onLoaded = (item) => {
    document.title = `Редактирование клиента ${item.name}`;
  };

  handlePostSave = (context, item) => {
    this.props.history.push(`/client/${item.id}`);
  };

  render() {
    const { match, history } = this.props;
    return (
      <DetailProvider
        url={`client/${match.params.id}`}
        onLoaded={(item) => this.onLoaded(item)}
      >
        <DetailContext.Consumer>
          {detailContext => {
            let { item } = detailContext;
            return (
              <FormProvider
                url={item.meta.url}
                postSaveMessage={'Клиент обновлен'}
                postSave={(item) => this.handlePostSave(detailContext, item)}
                item={item}
              >
                <FormContext.Consumer>
                {formContext => {
                  const { loading } = formContext;
                  return (
                    <Layout>
                      <StyledClientDetailOrders>
                        <div>
                          <ClientDetailHeader item={item} history={history} match={match} />

                          <Layout.ContentSimple>
                            <ClientAddForm />

                            <div className={'mt-30'}>
                              <YellowButton
                                onClick={(e) => formContext.handleSubmit(e)}
                                disabled={loading}
                                size={'large'}
                              >
                                Обновить клиента
                              </YellowButton>
                            </div>

                            <div className={'h-250'} />

                          </Layout.ContentSimple>
                        </div>
                      </StyledClientDetailOrders>
                    </Layout>
                  )
                }}
                </FormContext.Consumer>
              </FormProvider>
            )
          }}
        </DetailContext.Consumer>
      </DetailProvider>
    )
  }
}
